module.exports = __webpack_public_path__ + "static/img/leman.505de80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/unsplash/leman.jpg
// module id = 21Ti
// module chunks = 0